import React from 'react';

const buildMapImageSrc = (lat, lng) => {
    return `https://maps.googleapis.com/maps/api/staticmap?${[
        `maptype=roadmap`,
        `size=512x300`,
        `key=AIzaSyAS9QXHFdfVsUrKQ-PSKPqn7GIe2PKGV3o`,
        `center=${lat},${lng}`,
        `zoom=18`,
        `markers=${lat},${lng}`
    ].join('&')}`;
};

const buildMapHref = (lat, lng) => {
    return `https://www.google.com/maps/place/${lat},${lng}/${lat},${lng},15z`;
};

export function Map({lat, lng, title}) {
    if (!lat || !lng) return null;

    const parsedLat = parseFloat(lat);
    const parsedLng = parseFloat(lng);

    return (
        <div className="map">
            <a href={buildMapHref(parsedLat, parsedLng)} target="_blank">
                <img 
                    src={buildMapImageSrc(parsedLat, parsedLng)}
                    width="100%"
                    alt={title || ''}
                />
            </a>
        </div>
    );
}

export default Map;

